
<div class="others-dialog">

  <!-- ================= HEADER ================= -->
  <div class="dialog-header">

    <div class="header-icon">
      <mat-icon>
        {{
          data.type === 'vessel' ? 'directions_boat' :
          data.type === 'port' ? 'location_on' :
          data.type === 'cargo' ? 'inventory_2' :
          data.type === 'portagent' ? 'support_agent' :
          data.type === 'purpose' ? 'assignment' :
          'add_circle'
        }}
      </mat-icon>
    </div>

    <div class="header-content">
      <h2>{{ title }}</h2>

      <p>
        Add a new
        {{
          data.type === 'portagent'
            ? 'port agent'
            : data.type === 'purpose'
              ? 'purpose'
              : data.type
        }}.
      </p>
    </div>

    <button
      type="button"
      mat-icon-button
      class="close-button"
      (click)="cancel()"
      aria-label="Close"
    >
      <mat-icon>close</mat-icon>
    </button>

  </div>


  <!-- ================= CONTENT ================= -->
  <div
    mat-dialog-content
    [formGroup]="othersForm"
    class="dialog-content"
  >

    <!-- ===================================================== -->
    <!-- VESSEL -->
    <!-- ===================================================== -->

    <ng-container *ngIf="data.type === 'vessel'">

      <div class="field-section">

        <div class="field-title">
          <mat-icon>directions_boat</mat-icon>
          <span>Vessel Information</span>
        </div>

        <mat-form-field appearance="outline" class="full-width">

          <mat-label>Vessel Name</mat-label>

          <mat-icon matPrefix>
            directions_boat
          </mat-icon>

          <input
            matInput
            formControlName="vessel_name"
            placeholder="Enter vessel name"
            autocomplete="off"
          />

          <mat-error
            *ngIf="othersForm.get('vessel_name')?.hasError('required')"
          >
            Vessel Name is required.
          </mat-error>

        </mat-form-field>


        <mat-form-field appearance="outline" class="full-width">

          <mat-label>IMO Number</mat-label>

          <mat-icon matPrefix>
            numbers
          </mat-icon>

          <input
            matInput
            formControlName="imo_number"
            maxlength="7"
            inputmode="numeric"
            placeholder="Enter 7-digit IMO number"
            autocomplete="off"
          />

          <mat-hint>
            Enter a valid 7-digit IMO number
          </mat-hint>

          <mat-error
            *ngIf="othersForm.get('imo_number')?.hasError('required')"
          >
            IMO Number is required.
          </mat-error>

          <mat-error
            *ngIf="othersForm.get('imo_number')?.hasError('pattern')"
          >
            Please enter a valid IMO number.
          </mat-error>

        </mat-form-field>
         <mat-form-field appearance="outline" class="full-width">

          <mat-label>Head Owners Name</mat-label>

          <mat-icon matPrefix>
            directions_boat
          </mat-icon>

          <input
            matInput
            formControlName="head_owners_name"
            placeholder="Enter Head Owners name"
            autocomplete="off"
          />

          <mat-error
            *ngIf="othersForm.get('head_owners_name')?.hasError('required')"
          >
            Head Owners Name is required.
          </mat-error>

        </mat-form-field>
      </div>

    </ng-container>


    <!-- ===================================================== -->
    <!-- PORT -->
    <!-- ===================================================== -->

    <ng-container *ngIf="data.type === 'port'">

      <div class="field-section">

        <div class="field-title">
          <mat-icon>location_on</mat-icon>
          <span>Port Information</span>
        </div>

        <mat-form-field appearance="outline" class="full-width">

          <mat-label>Port Name</mat-label>

          <mat-icon matPrefix>
            location_on
          </mat-icon>

          <input
            matInput
            formControlName="port_name"
            placeholder="Enter port name"
            autocomplete="off"
          />

          <mat-error
            *ngIf="othersForm.get('port_name')?.hasError('required')"
          >
            Port Name is required.
          </mat-error>

        </mat-form-field>

         <!-- Country -->
    <mat-form-field appearance="outline" class="full-width">

      <mat-label>Country</mat-label>

      <mat-icon matPrefix>
        public
      </mat-icon>

      <input
        matInput
        formControlName="country_name"
        placeholder="Enter country name"
        autocomplete="off"
      />

      <mat-error
        *ngIf="othersForm.get('country_name')?.hasError('required')"
      >
        Country is required.
      </mat-error>

    </mat-form-field>

      </div>

    </ng-container>


    <!-- ===================================================== -->
    <!-- CARGO -->
    <!-- ===================================================== -->

    <ng-container *ngIf="data.type === 'cargo'">

      <div class="field-section">

        <div class="field-title">
          <mat-icon>inventory_2</mat-icon>
          <span>Cargo Information</span>
        </div>

        <mat-form-field appearance="outline" class="full-width">

          <mat-label>Cargo</mat-label>

          <mat-icon matPrefix>
            inventory_2
          </mat-icon>

          <input
            matInput
            formControlName="cargo"
            placeholder="Enter cargo type"
            autocomplete="off"
          />

          <mat-error
            *ngIf="othersForm.get('cargo')?.hasError('required')"
          >
            Cargo is required.
          </mat-error>

        </mat-form-field>

      </div>

    </ng-container>


    <!-- ===================================================== -->
    <!-- PORT AGENT -->
    <!-- ===================================================== -->

    <ng-container *ngIf="data.type === 'portagent'">

      <div class="field-section">

        <div class="field-title">
          <mat-icon>support_agent</mat-icon>
          <span>Port Agent Information</span>
        </div>

        <mat-form-field appearance="outline" class="full-width">

          <mat-label>Port Agent Name</mat-label>

          <mat-icon matPrefix>
            business
          </mat-icon>

          <input
            matInput
            formControlName="portagent_name"
            placeholder="Enter port agent name"
            autocomplete="off"
          />

          <mat-error
            *ngIf="othersForm.get('portagent_name')?.hasError('required')"
          >
            Port Agent Name is required.
          </mat-error>

        </mat-form-field>


        <mat-form-field appearance="outline" class="full-width">

          <mat-label>Email</mat-label>

          <mat-icon matPrefix>
            email
          </mat-icon>

          <input
            matInput
            type="email"
            formControlName="email"
            placeholder="Enter email address"
            autocomplete="off"
          />

          <mat-error
            *ngIf="othersForm.get('email')?.hasError('required')"
          >
            Email is required.
          </mat-error>

          <mat-error
            *ngIf="othersForm.get('email')?.hasError('email')"
          >
            Please enter a valid email.
          </mat-error>

        </mat-form-field>

      </div>

    </ng-container>


    <!-- ===================================================== -->
    <!-- PURPOSE -->
    <!-- ===================================================== -->

    <ng-container *ngIf="data.type === 'purpose'">

      <div class="field-section">

        <div class="field-title">
          <mat-icon>assignment</mat-icon>
          <span>Purpose Information</span>
        </div>

        <mat-form-field appearance="outline" class="full-width">

          <mat-label>Purpose</mat-label>

          <mat-icon matPrefix>
            assignment
          </mat-icon>

          <input
            matInput
            formControlName="purpose"
            placeholder="Enter purpose"
            autocomplete="off"
          />

          <mat-error
            *ngIf="othersForm.get('purpose')?.hasError('required')"
          >
            Purpose is required.
          </mat-error>

        </mat-form-field>

      </div>

    </ng-container>

  </div>


  <!-- ================= FOOTER ================= -->

  <div class="dialog-footer">

    <button
      mat-stroked-button
      type="button"
      class="btn btn-light hover-button mail"
      (click)="cancel()"
    >
      <mat-icon>close</mat-icon>
      Cancel
    </button>

    <button
      class="btn btn-light hover-button mail"
      [disabled]="othersForm.invalid"
      (click)="save()"
    >
      <mat-icon>check</mat-icon>
      Save
    </button>

  </div>

</div>

